(function () {
  'use strict';

  async function fetchWithRetry(url, options = {}, config = {}) {
    const {
      maxRetries = 3,
      retryDelay = 1000,
      exponentialBackoff = true,
      shouldRetry = (response) => !response.ok,
      onRetry = () => {},
    } = config;

    let lastError;

    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        const response = await fetch(url, options);

        if (!shouldRetry(response)) {
          return response;
        }

        if (attempt < maxRetries) {
          const delay = exponentialBackoff
            ? retryDelay * Math.pow(2, attempt)
            : retryDelay;
          onRetry(attempt + 1, maxRetries, response);
          await new Promise((resolve) => setTimeout(resolve, delay));
          lastError = new Error(`Response not ok: ${response.status}`);
        } else {
          return response;
        }
      } catch (error) {
        lastError = error;

        if (attempt < maxRetries) {
          const delay = exponentialBackoff
            ? retryDelay * Math.pow(2, attempt)
            : retryDelay;
          onRetry(attempt + 1, maxRetries, error);
          await new Promise((resolve) => setTimeout(resolve, delay));
        } else {
          throw error;
        }
      }
    }

    throw lastError || new Error('Max retries exceeded');
  }

  async function jsonRequest(url, options = {}) {
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    };

    const finalOptions = { ...options, ...defaultOptions };

    if (finalOptions.body && typeof finalOptions.body !== 'string') {
      finalOptions.body = JSON.stringify(finalOptions.body);
    }

    const response = await fetch(url, finalOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async function retryAsync(fn, config = {}) {
    const {
      maxRetries = 3,
      retryDelay = 1000,
      exponentialBackoff = true,
      shouldRetry = () => true,
      onRetry = () => {},
    } = config;

    let lastError;

    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        const result = await fn();
        return result;
      } catch (error) {
        lastError = error;

        if (attempt < maxRetries && shouldRetry(error)) {
          const delay = exponentialBackoff
            ? retryDelay * Math.pow(2, attempt)
            : retryDelay;
          onRetry(attempt + 1, maxRetries, error);
          await new Promise((resolve) => setTimeout(resolve, delay));
        } else {
          throw error;
        }
      }
    }

    throw lastError || new Error('Max retries exceeded');
  }

  function validateResponse(response) {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  }

  function validateJSON(data) {
    if (data === null || data === undefined) {
      throw new Error('Invalid JSON response: null or undefined');
    }
    return data;
  }

  window.requestUtils = {
    fetchWithRetry,
    jsonRequest,
    retryAsync,
    validateResponse,
    validateJSON,
  };
})();
